import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container d-flex" }
const _hoisted_2 = { class: "d-flex justify-content-end col-10" }
const _hoisted_3 = { class: "navbar navbar-expand-lg pt-0 pb-0 container__tablet-screen" }
const _hoisted_4 = { class: "collapse navbar-collapse" }
const _hoisted_5 = { class: "navbar-nav justify-content-xl-end w-100" }
const _hoisted_6 = { class: "w-100" }
const _hoisted_7 = { class: "container d-flex flex-row justify-content-between align-items-center" }
const _hoisted_8 = { class: "navbar-nav" }
const _hoisted_9 = { class: "d-flex w-100 justify-content-end" }
const _hoisted_10 = {
  id: "login-button-container",
  class: "d-flex align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMenuChildComponent = _resolveComponent("HeaderMenuChildComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_HeaderMenuChildMobComponent = _resolveComponent("HeaderMenuChildMobComponent")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: "header-menu",
    class: _normalizeClass({ 'dont_print': _ctx.store.state.customer.printing })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex align-items-center col-2" }, [
        _createElementVNode("a", { href: "/" }, [
          _createElementVNode("img", {
            src: "/favicon.png",
            class: "main_webpage_logo",
            alt: "Logo"
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuData, (mainNode) => {
                return (_openBlock(), _createBlock(_component_HeaderMenuChildComponent, {
                  key: mainNode.id,
                  "main-node": mainNode
                }, null, 8, ["main-node"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createVNode(_component_ButtonComponent, {
                onClick: _ctx.toggleMeniu,
                class: "navbar-toggler mob-navbar-toggler",
                type: "button"
              }, {
                btnContent: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("span", { class: "mob-navbar-icon" }, null, -1)
                ])),
                _: 1
              }, 8, ["onClick"]), [
                [_vShow, _ctx.toggle]
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.isOpen ? 'container__meniu-mob-left container__meniu-mob-left__animation d-lg-none' : null)
            }, [
              _withDirectives(_createElementVNode("ul", _hoisted_8, [
                _createElementVNode("li", _hoisted_9, [
                  _createVNode(_component_ButtonComponent, {
                    onClick: _ctx.toggleMeniu,
                    class: "mob-close-button"
                  }, {
                    btnContent: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createElementVNode("span", { class: "times" }, "×", -1)
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuData, (mainNode) => {
                  return (_openBlock(), _createBlock(_component_HeaderMenuChildMobComponent, {
                    key: mainNode.id,
                    "main-node": mainNode
                  }, null, 8, ["main-node"]))
                }), 128))
              ], 512), [
                [_vShow, _ctx.isOpen]
              ])
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: !_ctx.store.getters['customer/isLoggedIn'] ? _ctx.routes.LOGIN : _ctx.routes.PROFILE,
            title: _ctx.store.getters['customer/isLoggedIn'] ? _ctx.$t('profile') : _ctx.$t('login')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_ButtonComponent, { class: "button-container-white login-button d-none d-lg-flex" }, {
                btnContent: _withCtx(() => [
                  (!_ctx.store.getters['customer/isLoggedIn'])
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('login')), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.store.state.customer.company_name)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.store.state.customer.company_name), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_ctx.store.state.customer.first_name ?? '') + " " + _toDisplayString(_ctx.store.state.customer.last_name ?? ''), 1)
                            ], 64))
                      ], 64))
                ]),
                _: 1
              }, 512), [
                [_vShow, parseInt(_ctx.store.state.socialAuth.enable_login_setting) === 1]
              ]),
              _createVNode(_component_ButtonComponent, {
                class: _normalizeClass(["mob-button-container-white mob-login-button d-lg-none", { 'mob-profile-button': _ctx.store.getters['customer/isLoggedIn'] }])
              }, {
                btnContent: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-user" })
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["to", "title"])
        ])
      ])
    ])
  ], 2))
}